import balloons from "./balloons";
import bases from "./bases";
import backgrounds from "./backgrounds";

export default {
    balloons,
    bases,
    backgrounds
};



// WEBPACK FOOTER //
// ./src/imgs/bottles/index.js